const moment = require("moment");
const ActionType = require("../action-types/promocodes");
const Deeply = require("utils/deeply");

const internals = {
    initial: () => ({
        isUploading: false
    })
};

module.exports = (state, action) => {
    const { type, payload } = action;
    state = state || internals.initial();

    switch (type) {
        case ActionType.GIFT_CREDITS_BEGIN:
            return Deeply(state)
                .set("isUploading", true)
                .value();

        case ActionType.GIFT_CREDITS_FAILURE:
        case ActionType.GIFT_CREDITS_SUCCESS:
            return Deeply(state)
                .set("isUploading", false)
                .value();
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/giftcredits.js